import React, { useEffect, useState } from 'react';
import githubService from '../../services/github.service';


function AnalyticVersions() {
    const [webJobs, setWebJobs] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const response = await githubService.getanalyticsversions();
                if (response) {
                    setWebJobs(response); 
                }
            } catch (e) {
                console.log(e);
            }
            finally {
                setLoading(false);
            }
        };
        fetchData();
    
    }, []);

    return (
        <div className="version-container">
            <h2>Analytics Versions</h2>
                <table className="table table-striped table-bordered table-sm" aria-labelledby="tableLabel">
                <thead>
                <tr>
                    <th>ID</th>
                    <th>Job Name</th>
                    <th>Version</th>
                    <th>Deployment Date</th>
                </tr>
                </thead>
                <tbody>
                {webJobs?.map(job => (
                    <tr key={job.id}>
                        <td>{job.id}</td>
                        <td>{job.jobName}</td>
                        <td>{job.version}</td>
                        <td>{job.deploymentDate}</td>
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
    );
};

export default AnalyticVersions;